export const SPANISH = "es";
export const CATALAN = "ca";
